import cx from 'classnames'
import * as React from 'react'

import { SpacingProps } from '../shared-types'
import Spacer from '../spacer'
import styles from './badge.module.scss'

export type Props = {
  status?: 'info' | 'success' | 'danger' | 'warning'
  children: React.ReactNode
} & SpacingProps

export default function Badge(props: Props) {
  const { children, status = 'info', ...otherProps } = props

  const classNames = cx({
    [styles.root]: true,
    [styles[`status-${status}`]]: true,
  })

  return (
    <Spacer {...otherProps} className={classNames}>
      <span>{children}</span>
    </Spacer>
  )
}
